import { SeoPageLayout } from "@/components/SeoPageLayout";
import { SeoSection } from "@/components/seo/SeoSection";
import { SeoStyledList } from "@/components/seo/SeoStyledList";
import { SeoHighlightBox } from "@/components/seo/SeoHighlightBox";
import { Globe } from "lucide-react";

const StandUpPoAngielsku = () => (
  <SeoPageLayout title="Stand-up" titleAccent="po angielsku">
    <SeoSection title="Stand-up comedy in English">
      <p>W erze globalizacji coraz więcej firm w Polsce zatrudnia międzynarodowe zespoły. Jeśli Twoja organizacja działa w języku angielskim lub wśród gości są obcokrajowcy, oferujemy profesjonalne występy stand-up comedy w języku angielskim. Ten sam poziom humoru, personalizacji i profesjonalizmu - w uniwersalnym języku.</p>
    </SeoSection>
    <SeoSection title="Dla kogo stand-up po angielsku?">
      <SeoStyledList items={[
        "Międzynarodowe korporacje z zespołami wielojęzycznymi",
        "Firmy IT i tech z pracownikami z zagranicy",
        "Centra usług wspólnych (SSC/BPO) z międzynarodowym zespołem",
        "Eventy i konferencje z zagranicznymi gośćmi",
        "Firmy z zagranicznymi klientami i partnerami biznesowymi"
      ]} />
    </SeoSection>
    <SeoSection title="Dwujęzyczny występ">
      <p>Oferujemy również unikalne występy dwujęzyczne - mieszankę polskiego i angielskiego humoru, która bawi zarówno Polaków, jak i obcokrajowców. Komik płynnie przechodzi między językami, nawiązując do zabawnych różnic kulturowych i sytuacji, które znają wszyscy pracownicy międzynarodowych firm.</p>
      <SeoHighlightBox icon={Globe}>
        Występ dwujęzyczny to idealny format dla firm z mieszanymi zespołami - humor łączy kultury i buduje mosty między pracownikami.
      </SeoHighlightBox>
    </SeoSection>
    <SeoSection title="Tematy stand-upu po angielsku">
      <p>Materiał anglojęzyczny obejmuje uniwersalne tematy korporacyjne - spotkania na Zoomie, korporacyjny slang, różnice kulturowe w pracy, absurdy biurowe i typowe sytuacje w międzynarodowych firmach. Komik personalizuje materiał pod Twoją firmę, dodając lokalne akcenty i wewnętrzne nawiązania.</p>
    </SeoSection>
  </SeoPageLayout>
);

export default StandUpPoAngielsku;
